module.exports = __webpack_public_path__ + "prod/1.42.2/img/xtrh_four.d4b3768e.png";